import { createSerializer, parseAsInteger, parseAsString } from "nuqs";

import { RecordStatus } from "@components/custom/dropdowns/record-status-dropdown";

/**
 * Centralized search params parsers for the application.
 * These parsers provide type-safe URL query parameter handling.
 */

// Common navigation parameters
export const fromParser = (defaultValue) =>
  parseAsString.withDefault(defaultValue);
export const classroomIdParser = parseAsString;
export const pathParser = parseAsString;
export const productParser = (defaultValue) =>
  parseAsInteger.withDefault(defaultValue);
export const tabParser = parseAsString;
export const previewParser = parseAsString;
export const metricParser = parseAsString;
export const statusParser = (defaultValue) =>
  parseAsString.withDefault(defaultValue);

/**
 * Parser configurations for different views/features
 */

// Trainee detail view parameters
export const traineeDetailParams = {
  from: fromParser("All Users"),
  classroomId: classroomIdParser,
  product: productParser(),
  path: pathParser,
};

// Classroom detail view parameters
export const classroomDetailParams = {
  from: fromParser("All Classrooms"),
  tab: tabParser,
  product: productParser(),
};

// My Work trainee detail parameters
export const myWorkTraineeDetailParams = {
  courseId: parseAsString,
};

// Dashboard parameters
export const dashboardParams = {
  from: parseAsString,
  product: parseAsInteger,
};

// Classrooms list view parameters
export const classroomsParams = {
  status: statusParser(RecordStatus.Active),
  product: parseAsString,
};

// Outcomes view parameters
export const outcomesParams = {
  q: parseAsString.withDefault(""),
  metric: metricParser,
  // Exclusive series selection for a multi-series metric (e.g. an award type or
  // product line). Empty means "unset" — the view falls back to the persisted
  // per-metric selection; "all" shows every series.
  series: parseAsString.withDefault(""),
};

/**
 * Serializers for creating navigation links
 */
export const serializeTraineeDetailParams =
  createSerializer(traineeDetailParams);
export const serializeClassroomDetailParams = createSerializer(
  classroomDetailParams
);

export const serializeMyWorkTraineeDetailParams = createSerializer(
  myWorkTraineeDetailParams
);
export const serializeDashboardParams = createSerializer(dashboardParams);

/**
 * Generic serializer for ad-hoc parameters
 * Uses nuqs for proper serialization with all parameter types
 */
const genericParamsSchema = {
  from: fromParser("Back"),
  classroomId: classroomIdParser,
  product: productParser(),
  tab: tabParser,
  preview: previewParser,
  path: pathParser,
};

export const serializeParams = createSerializer(genericParamsSchema);
export const serializeOutcomesParams = createSerializer(outcomesParams);
